import Box from '@mui/material/Box';
import List from '@mui/material/List';
import { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { WsDrawer } from 'wisestep-base';

import { pipelineEmptyValues } from '../../../features/jobsCrm/components/helper/JobCrmEmptyValues';
import { NoticePeriod, SalaryRangeFilter, SourceFilter, TagsFilter } from '../components';
import AdvanceFilterFooterBar from '../components/AdvanceFilterFooterBar';
import { contactPreferences, workAuthorization } from '../components/AdvanceFilterHelper';
import BusinessDefinitionFilter from '../components/BusinessDefinitionFilter';
import CheckboxListFilter from '../components/CheckboxListFilter';
import RecruiterAutoCompleteInputFilter from '../components/RecruiterAutoCompleteInputFilter';
import RelocationPreferenceFilter from '../components/RelocationPreferenceFilter';
import JobsCrmPipelineAdvanceFiltersFormProps from '../models/JobsCrmPipelineAdvanceFiltersFormProps';
import JobsCrmPipelineAdvanceFiltersProps from '../models/JobsCrmPipelineAdvanceFiltersProps';

const WsJobsCrmPipelineAdvanceFilters = ({
  open = false,
  filterClose,
  onApplyFilters,
  defaultValues,
}: JobsCrmPipelineAdvanceFiltersProps) => {
  const methods = useForm<JobsCrmPipelineAdvanceFiltersFormProps>({ defaultValues: {} });
  const { handleSubmit, reset } = methods;

  useEffect(() => {
    reset(defaultValues);
  }, [defaultValues, reset]);

  const resetDefault = () => {
    reset(pipelineEmptyValues);
  };

  const onFormSubmit = (data: JobsCrmPipelineAdvanceFiltersFormProps) => {
    onApplyFilters(data);
    filterClose && filterClose();
  };

  return (
    <FormProvider {...methods}>
      <WsDrawer
        title="Advanced Filters"
        open={open}
        onClose={() => filterClose && filterClose()}
        size="medium"
        headerSize="medium"
      >
        <Box
          component="form"
          role="presentation"
          onSubmit={handleSubmit(onFormSubmit)}
          onReset={resetDefault}
        >
          <Box pb={7}>
            <List>
              <TagsFilter name="tags" defaultValue={defaultValues?.tags} />
              <BusinessDefinitionFilter name="currentStageCurrentStatusPairs" />
              <RelocationPreferenceFilter name="relocationPreferences" />
              <SalaryRangeFilter />
              <CheckboxListFilter
                name="workAuthorization"
                options={workAuthorization}
                title="Work Authorization"
              />
              <SourceFilter name="source" defaultValue={defaultValues?.source} />
              <CheckboxListFilter
                name="commPreferences"
                options={contactPreferences}
                title="Communication Preference"
              />
              <CheckboxListFilter
                name="contactAvailability"
                options={contactPreferences}
                title="Contact Availability"
              />
              <NoticePeriod name="noticePeriod" />
              <RecruiterAutoCompleteInputFilter name="createdBy" title="CreatedBy" />
            </List>
          </Box>
          <AdvanceFilterFooterBar />
        </Box>
      </WsDrawer>
    </FormProvider>
  );
};
export default WsJobsCrmPipelineAdvanceFilters;
